import { addToChainAfter, ApiHandler } from "@insite/client-framework/HandlerCreator";
import { Session, updateSession } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    RequestSession,
    SignInParameter,
    SignInResult,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { performGeolocationWarehouseSelection } from "@WhiteCap/Handlers/WarehouseHandler/performGeolocationWarehouseSelection";

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        authenticatedSession?: Session;
    }
>;

export const PerformGeolocationIfNeeded: HandlerType = async props => {
    if (!props.authenticatedSession) {
        return;
    }

    const session = props.authenticatedSession as any;
    const shouldPerformGeolocation = session.properties?.isGeoLocateRequired?.toLowerCase() === "true";

    if (!shouldPerformGeolocation) {
        return;
    }

    sessionStorage.setItem("signInGeolocationInProgress", "true");
    const warehouseId = await performGeolocationWarehouseSelection();
    sessionStorage.removeItem("signInGeolocationInProgress");

    if (warehouseId) {
        // Set flag to prevent LocationHelper from overriding
        sessionStorage.setItem("warehouseSetBySignIn", "true");

        const updatedSession = await updateSession({
            session: {
                pickUpWarehouse: { id: warehouseId } as WarehouseModel,
                customerWasUpdated: false,
                fulfillmentMethod: props.authenticatedSession.fulfillmentMethod || "Ship",
            } as Session,
        });

        props.authenticatedSession = updatedSession as Session;
        props.dispatch({
            type: "Context/CompleteLoadSession",
            session: updatedSession,
        });
    }
};

addToChainAfter(chain, RequestSession, PerformGeolocationIfNeeded);
